// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product--sparkling-water .cart-input--radios{flex:0 1 auto;max-width:50%;min-width:0;text-align:center}.product--sparkling-water .radio-group.input label{padding-left:0}.product__nutrition-facts ul{display:block;font-size:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
